module.exports = __webpack_public_path__ + "static/media/weekend_papers_footy2024.43f26a31.png";